// Babel polyfills for old browsers
import 'core-js/stable'
import 'regenerator-runtime/runtime'

// imports
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import App from './App.js'
import configureStore from './configureStore.js'
import * as serviceWorker from './serviceWorker'
import * as Sentry from '@sentry/browser'

const HOST = process.env.HOST
const SENTRY_DSN = process.env.SENTRY_DSN

// initialize Sentry error logging
if (SENTRY_DSN)
  Sentry.init({ tunnel: '/sentry-tunnel/', dsn: SENTRY_DSN, environment: HOST })

const rootElement = document.getElementById('app')

const stopDoubleClickSelect = ev => {
  // event.detail is the number of mouse clicks in a sequence
  // single click is 1, double click is 2 etc.
  // this disables the default text selection behaviour of double and triple
  // clicks
  if (ev.detail && ev.detail > 1) {
    // keep default if event target is a form element
    if (!('form' in ev.target)) ev.preventDefault()
  }
}

document.removeEventListener('mousedown', stopDoubleClickSelect)
document.addEventListener('mousedown', stopDoubleClickSelect)

const render = (App, store) =>
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    rootElement,
  )

const store = configureStore()
render(App, store)
if (module.hot)
  module.hot.accept('./App', () => {
    render(require('./App').default, store)
  })

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
